import type { FC } from 'react';

import styles from './ScrollArrows.module.css';

interface LeftArrowProps {
  onClick: () => void;
}

const LeftArrow: FC<LeftArrowProps> = ({ onClick }) => {
  return (
    <div
      className={styles.leftScrollArrow}
      onClick={onClick}
    >
      <div className={styles.scrollArrowIcon}>
        <svg
          viewBox="0 0 24 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.scrollArrowSvg}
        >
          <path
            d="M3.6.6,12,8.8,20.4.6a2.18,2.18,0,0,1,3,0,2,2,0,0,1,0,2.8L12.6,14.6a1.76,1.76,0,0,1-1.2.6,1.76,1.76,0,0,1-1.2-.6L.6,3.4a2,2,0,0,1,0-2.8A2.18,2.18,0,0,1,3.6.6Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </div>
  )
}

export default LeftArrow;
